import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import Div from '../Page/Div';
const SelectButtons = ({ options, multiSelect, selection, blocked, onSelection, }) => {
    const [unselected, setUnselected] = useState(null);
    const onFilterClick = (item) => {
        if (selection.includes(item)) {
            onSelection(null);
            setUnselected(item);
        }
        else {
            onSelection(item);
            setUnselected(null);
        }
    };
    return (_jsx(Div, { className: "products-filters", delay: 2, blocked: blocked, children: options.map((filter) => {
            const { name, category } = filter;
            return (_jsx("div", { className: `button${selection.includes(category) ? ' selected' : ''}${category === unselected ? ' unselected' : ''}`, onMouseLeave: () => setUnselected(null), onClick: () => onFilterClick(category), children: name }, name));
        }) }));
};
export default SelectButtons;
